module.exports = __webpack_public_path__ + "static/media/close-outlined.ca092a76.svg";